var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Field } from 'formik';
import React from 'react';
import { RangeSliderComponent } from './RangeSliderComponent';
export var RangeSliderComponentContainer = function (props) {
    return React.createElement(Field, __assign({}, props, { component: RangeSliderComponent }));
};
RangeSliderComponentContainer.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=RangeSliderComponentContainer.js.map